var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C3.36445 15 0 11.6356 0 7.5C0 3.36445 3.36445 0 7.5 0C11.6356 0 15 3.36445 15 7.5C15 11.6356 11.6356 15 7.5 15Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1786 10.7143C10.0415 10.7143 9.90441 10.662 9.79981 10.5573L4.44272 5.20019C4.23341 4.99088 4.23341 4.65191 4.44272 4.44271C4.65192 4.23351 4.99101 4.2334 5.2002 4.44271L10.5573 9.7998C10.7666 10.0091 10.7666 10.3481 10.5573 10.5573C10.4527 10.662 10.3157 10.7143 10.1786 10.7143Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82141 10.7143C4.68431 10.7143 4.54732 10.662 4.44272 10.5573C4.23341 10.3481 4.23341 10.009 4.44272 9.79981L9.79981 4.44272C10.0091 4.23341 10.3481 4.23341 10.5573 4.44272C10.7665 4.65192 10.7666 4.99101 10.5573 5.2002L5.2002 10.5573C5.09561 10.662 4.95851 10.7143 4.82141 10.7143V10.7143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDelete);
export default __webpack_public_path__ + "static/media/close_delete.90160d25bd7130e933abaed122319696.svg";
export { ForwardRef as ReactComponent };